import { compose } from 'recompose';
import withE2EProp from '../../withE2EProp';
import centeredQuestion from '../hoc/centeredQuestion';
import SingleQuestion from '../SingleQuestion';

export default compose(
  withE2EProp('respondent-custom-radio'),
  centeredQuestion,
)(SingleQuestion);
